import React, { useEffect, Fragment } from 'react'
import { connect } from 'dva'
import BaseInfo from './BaseInfo'
import Address from './Address'
import BankCard from './BankCard'
import IdCard from './IdCard'
import './Info.module.less'

const Info = ({ dispatch }) => {
  useEffect(() => {
    dispatch({
      type: 'global/getUserAddress',
    })
    dispatch({
      type: 'global/getPersonalBankCards',
    })
    dispatch({
      type: 'global/getAreas',
    })
    dispatch({
      type: 'center/initBasicData',
    })
    dispatch({
      type: 'global/getIdCardCheck',
    })
  }, [dispatch])

  return (
    <Fragment>
      <BaseInfo />
      <Address />
      <BankCard />
      <IdCard />
    </Fragment>
  )
}

export default connect(() => {
  return {}
})(Info)
